var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from "shared/api/axios-instance";
var adminDataProvider = {
    getApiUrl: function () { var _a; return (_a = process.env.REACT_APP_BACKEND_URL) !== null && _a !== void 0 ? _a : ""; },
    getList: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var _c, _d, current, _e, pageSize, data;
        var _f, _g, _h;
        var resource = _b.resource, pagination = _b.pagination;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    _c = pagination !== null && pagination !== void 0 ? pagination : {}, _d = _c.current, current = _d === void 0 ? 1 : _d, _e = _c.pageSize, pageSize = _e === void 0 ? 10 : _e;
                    return [4 /*yield*/, api.get("/admin/".concat(resource), {
                            params: { page: current, limit: pageSize },
                        })];
                case 1:
                    data = (_j.sent()).data;
                    return [2 /*return*/, {
                            data: (_f = data.data) !== null && _f !== void 0 ? _f : data,
                            total: (_g = data.total) !== null && _g !== void 0 ? _g : ((_h = data.data) !== null && _h !== void 0 ? _h : data).length,
                        }];
            }
        });
    }); },
    getOne: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var data;
        var resource = _b.resource, id = _b.id;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, api.get("/admin/".concat(resource, "/").concat(id))];
                case 1:
                    data = (_c.sent()).data;
                    return [2 /*return*/, { data: data }];
            }
        });
    }); },
    create: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var data;
        var resource = _b.resource, variables = _b.variables;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, api.post("/admin/".concat(resource), variables)];
                case 1:
                    data = (_c.sent()).data;
                    return [2 /*return*/, { data: data }];
            }
        });
    }); },
    update: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var data;
        var resource = _b.resource, id = _b.id, variables = _b.variables;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, api.patch("/admin/".concat(resource, "/").concat(id), variables)];
                case 1:
                    data = (_c.sent()).data;
                    return [2 /*return*/, { data: data }];
            }
        });
    }); },
    deleteOne: function (_a) { return __awaiter(void 0, [_a], void 0, function (_b) {
        var data;
        var resource = _b.resource, id = _b.id;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, api.delete("/admin/".concat(resource, "/").concat(id))];
                case 1:
                    data = (_c.sent()).data;
                    return [2 /*return*/, { data: data }];
            }
        });
    }); },
};
export default adminDataProvider;
